import React, { Component } from 'react';
import { Popover } from 'antd';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';
import moment from 'moment';

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 11,
            },
            data: [],
            datakp:[]
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            const { pagination } = this.state;
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.props;
        // let beginDateDefault = moment().format('YYYY-MM');
        // let endDateDefault = moment().format('YYYY-MM');
        // const {
        //     beginDate,
        //     endDate,
        // } = searchParams;
        this.setState({ loading: true });
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        Fetch.post(API_URL.home.queryARContractList, {
            offset: current,
            limit: pageSize - 1,
            // beginDate:beginDate?beginDate:beginDateDefault,
            // endDate:endDate?endDate:endDateDefault,
            date:searchParams.date?searchParams.date:moment().format('YYYY-MM'),
            ...searchParams,
        }).then(res => {
            const { datas,totalCount } = res;
            pagination.total = totalCount + Math.ceil(totalCount / (pageSize - 1));
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: '收入归属单位',
            dataIndex: 'unitOfBelongingName',
            key: 'unitOfBelongingName',
            width: 100,
            fixed:"left"
        },{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 160,
            fixed:"left"
        },{
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 160,
        },{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        },{
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 160,
        },{
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 160,
        },{
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 160,
        },{
            title: '已记收入未开票',
            dataIndex: 'recordedNotInvoiced',
            key: 'recordedNotInvoiced',
            width: 160,
            render: (text, record) => {
                if(record.unitOfBelongingName&&record.unitOfBelongingName.indexOf("合计") != -1){
                    return (
                        <span className="boldText">
                           {record.recordedNotInvoiced}
                        </span>
                    );
                }else{
                    return(
                    <span>
                      {record.recordedNotInvoiced}
                    </span>
                    )     
                }
            },
        },{
            title: '未开票请款当月是否有到达milestone',
            dataIndex: 'milestoneNotInvoice',
            key: 'milestoneNotInvoice',
            width: 160,
        },{
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            width: 160,
        },{
            title: '预计开票金额不含税/人民币',
            dataIndex: 'planInvoiceNoTaxAmount',
            key: 'planInvoiceNoTaxAmount',
            width: 160,
            render: (text, record) => {
                if(record.unitOfBelongingName&&record.unitOfBelongingName.indexOf("合计") != -1){
                    return (
                        <span className="boldText">
                           {record.planInvoiceNoTaxAmount}
                        </span>
                    );
                }else{
                    return(
                    <span>
                      {record.planInvoiceNoTaxAmount}
                    </span>
                    )     
                }
            },
        },{
            title: '预计开票金额含税/人民币',
            dataIndex: 'planInvoiceAmount',
            key: 'planInvoiceAmount',
            width: 160,
            render: (text, record) => {
                if(record.unitOfBelongingName&&record.unitOfBelongingName.indexOf("合计") != -1){
                    return (
                        <span className="boldText">
                           {record.planInvoiceAmount}
                        </span>
                    );
                }else{
                    return(
                    <span>
                      {record.planInvoiceAmount}
                    </span>
                    )     
                }
            },
        },
        {
            title: 'milestone到达日期',
            dataIndex: 'milestoneDateShow',
            key: 'milestoneDateShow',
            width: 160,
            render: (text, record) => {
                if (record.milestoneDateTipList&&record.milestoneDateTipList.length>1) {
                    return (
                        <Popover placement="right" overlayClassName="gray-pop" content={
                            record.milestoneDateTipList.map((item, index) => (
                                    <div className="item" key={index} style={{marginBottom:"5px"}}>
                                        <p>请款单号：{item.str1}</p>
                                        <p>milestone到达日期：{item.str2}</p>
                                    </div>
                            ))
                            }>
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {text}
                            </div>
                        </Popover>
                    )
                } else {
                    return text;
                }
            }
        },
        {
            title: '预计开票月份',
            dataIndex: 'planInvoiceDateShow',
            key: 'planInvoiceDateShow',
            width: 160,
            render: (text, record) => {
                if (record.planInvoiceDateTipList&&record.planInvoiceDateTipList.length>1) {
                    return (
                        <Popover placement="right" overlayClassName="gray-pop" content={
                            record.planInvoiceDateTipList.map((item, index) => (
                                    <div className="item" key={index} style={{marginBottom:"5px"}}>
                                        <p>请款单号：{item.str1}</p>
                                        <p>确认可请款日期：{item.str2}</p>
                                    </div>
                            ))
                            }>
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {text}
                            </div>
                        </Popover>
                    )
                } else {
                    return text;
                }
            }
        },{
            title: '当前请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 160,
        },{
            title: '当前请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 160,
        },{
            title: '如BA修改开票日期的原因描述',
            dataIndex: 'baConfirmCashReqDateReason',
            key: 'baConfirmCashReqDateReason',
            width: 160,
            render: (text, record) => {
                if (record.reasonTipList&&record.reasonTipList.length>1) {
                    return (
                        <Popover placement="right" overlayClassName="gray-pop" content={
                            record.reasonTipList.map((item, index) => (
                                    <div className="item" key={index} style={{marginBottom:"5px"}}>
                                        <p>请款单号：{item.str1}</p>
                                        <p>修改时间：{item.str2}</p>
                                        <p>修改原因：{item.str3}</p>
                                    </div>
                            ))
                            }>
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {text}
                            </div>
                        </Popover>
                    )
                } else {
                    return text;
                }
            }
        },{
            title: '备注',
            dataIndex: 'paymentProgressComment',
            key: 'paymentProgressComment',
            width: 160,
            render: (text, record) => {
                if (record.paymentProgressTipList&&record.paymentProgressTipList.length>1) {
                    return (
                        <Popover placement="right" overlayClassName="gray-pop" content={
                            record.paymentProgressTipList.map((item, index) => (
                                    <div className="item" key={index} style={{marginBottom:"5px"}}>
                                        <p>请款单号：{item.str1}</p>
                                        <p>请款进度具体描述：{item.str2}</p>
                                    </div>
                            ))
                            }>
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {text}
                            </div>
                        </Popover>
                    )
                } else {
                    return text;
                }
            }
        },{
            title: '客户付款单位',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 160,
        },{
            title: '计收入确认方式',
            dataIndex: 'contractType',
            key: 'contractType',
            width: 160,
        },{
            title: '合同额含税/人民币',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            width: 160,
        },{
            title: '累计开票不含税/人民币',
            dataIndex: 'totalTaxableAmount',
            key: 'totalTaxableAmount',
            width: 160,
        },{
            title: '累计收入不含税/人民币',
            dataIndex: 'cnyTotalIncomeNoTax',
            key: 'cnyTotalIncomeNoTax',
            width: 160,
        },{
            title: '最近开票日',
            dataIndex: 'latestInvoiceDate',
            key: 'latestInvoiceDate',
            width: 160,
        },{
            title: '最近开票距今',
            dataIndex: 'latestDayNum',
            key: 'latestDayNum',
            width: 160,
        },{
            title: 'PM',
            dataIndex: 'pmName',
            key: 'pmName',
            width: 160,
            render: (text, record) => {
                const { pmName, pmCode } = record;
                return (pmName && pmCode) ? `${pmName}[${pmCode}]` : ''
            }
        },{
            title: '主领域leader',
            dataIndex: 'mainTalNameCode',
            key: 'mainTalNameCode',
            width: 160,
        }];
        return columns;
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    pagination={pagination}
                    // pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    className="unregisterRequest"
                />

            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ARSheet/ARSheetS/TablePage/List.js